<script setup>
const emit = defineEmits(['dismiss']);

defineProps({
  elementStates: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div
    v-for="(elementState, index) in elementStates"
    :key="index"
    class="tw-grid tw-grid-cols-12 tw-min-h-24 tw-overflow-hidden tw-border-grey-light"
    :class="{
      'tw-border-b': index !== elementState.length - 1,
    }"
  >
    <div class="tw-col-span-2 tw-px-4 tw-my-auto tw-text-center tw-font-bold">
      {{ elementState.tagName }}
    </div>

    <div class="tw-px-4 tw-col-span-1 tw-my-auto tw-text-center tw-font-bold">
      {{ elementState.published ? 'Published' : 'Saved' }}
    </div>

    <div
      v-if="elementState.tagName === 'a'"
      class="tw-px-4 tw-col-span-4 tw-my-auto tw-mx-auto"
    >
      -
    </div>

    <div
      v-else
      class="tw-px-4 tw-col-span-4 tw-my-auto tw-mx-auto"
      v-html="elementState.identifyingContent"
    />

    <div
      v-if="elementState.tagName === 'a'"
      class="tw-px-4 tw-col-span-4 tw-my-auto tw-mx-auto"
    >
      {{ elementState.domAttributes.find(attr => attr.attribute === 'href').value }}
    </div>

    <div
      v-else
      class="tw-px-4 tw-col-span-4 tw-my-auto tw-mx-auto"
      v-html="elementState.newContent"
    />

    <div class="tw-px-4 tw-col-span-1 tw-my-auto tw-mx-auto">
      <button
        v-tooltip="{
          content: 'Dismiss change',
          placement: 'bottom',
          theme: 'dark-blue-tooltip',
        }"
        class="tw-border-2 tw-border-blue tw-rounded-lg tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-transition-all tw-cursor-pointer hover:tw-shadow-blue tw-text-blue tw-bg-white"
        @click="emit('dismiss', elementState)"
      >
        <svg-vue
          icon="icons/trash"
          class="tw-w-4 tw-h-4 tw-flex-shrink-0"
        />
      </button>
    </div>
  </div>
</template>
